import { render } from "./AssessmentsView.vue?vue&type=template&id=c88d8e6a&scoped=true"
import script from "./AssessmentsView.vue?vue&type=script&lang=js"
export * from "./AssessmentsView.vue?vue&type=script&lang=js"

import "./AssessmentsView.vue?vue&type=style&index=0&id=c88d8e6a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c88d8e6a"]])

export default __exports__